<template>
  <div>
    <confirm-dialog ref="confirmDeleteDialog"
                    confirm-button-color="deep-orange"
                    v-bind:cancel-button-label="$t('cancel')"
                    v-bind:confirm-button-label="$t('delete')"
                    v-bind:message="$t('areYouSureYouWantToDeleteThisLearningDepartmentIrrevocably')"
                    v-bind:title="$t('deleteLearningDepartment')"
                    v-model="confirmDeleteDialog" />

    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="title | defaultValue($t('learningDepartment'))">
      <header-button icon="mdi-chevron-left"
                     slot="left-button"
                     v-bind:label="$t('back')"
                     v-bind:to="{ name: 'learning-departments' }" />

      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="updateLearningDepartment" />

      <v-menu slot="menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark
                 icon
                 v-bind="attrs"
                 v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-on:click="deleteLearningDepartment">
            <v-list-item-title class="deep-orange--text">{{ $t('delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container v-if="learningDepartment != null">
      <v-row>
        <v-col cols="12"
               lg="6">
          <learningDepartment-details-card ref="learningDepartmentDetailsCard"
                                v-bind:learningDepartment="learningDepartment" />
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import ConfirmDialog from '@/components/common/ConfirmDialog'
  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import LearningDepartmentDetailsCard from '@/components/learning/LearningDepartmentDetailsCard.vue'

  export default {
    async beforeRouteUpdate(to, from, next) {
      const id = parseInt(to.params.id)

      await this.get(id)

      next()
    },
    components: {
      ConfirmDialog,
      HeaderButton,
      LearningDepartmentDetailsCard,
      TopHeader
    },
    computed: {
      id() {
        return this.learningDepartment?.id
      },
      title() {
        return this.learningDepartment?.title
      },
      ...mapGetters({
        getLearningDepartment: 'learning/learningDepartment'
      })
    },
    async created() {
      const id = parseInt(this.$route.params.id)

      await this.get(id)
    },
    data: () => ({
      confirmDeleteDialog: false,
      loading: false,
      learningDepartment: null,
      validationSnackbar: false
    }),
    methods: {
      async deleteLearningDepartment() {
        await this.$refs.confirmDeleteDialog.open(async r => {
          if (!r) {
            return
          }

          this.loading = true

          await this.doDeleteLearningDepartment({ id: this.id })

          this.loading = false

          this.$router.push({ name: 'learning-departments' })
        })
      },
      async get(id) {
        this.loading = true

        await this.loadLearningDepartment({ id })

        this.loading = false

        this.learningDepartment = Object.assign({}, this.getLearningDepartment(id))
      },
      async updateLearningDepartment() {
        if (!this.$refs.learningDepartmentDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        this.loading = true

        await this.doUpdateLearningDepartment({ learningDepartment: this.learningDepartment })

        this.loading = false

        this.$router.push({ name: 'learning-departments' })
      },
      ...mapActions({
        doDeleteLearningDepartment: 'learning/deleteLearningDepartment',
        doUpdateLearningDepartment: 'learning/updateLearningDepartment',
        loadLearningDepartment: 'learning/loadLearningDepartment'
      })
    },
    name: 'LearningDepartment'
  }
</script>


<i18n>
  {
    "de": {
      "areYouSureYouWantToDeleteThisLearningDepartmentIrrevocably": "Sind Sie sicher, dass Sie diese Abteilung unwiderruflich löschen möchten?",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "deleteLearningDepartment": "Abteilung löschen",
      "save": "Speichern",
      "learningDepartment": "Abteilung",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "areYouSureYouWantToDeleteThisLearningDepartmentIrrevocably": "Are you sure you want to delete this department irrevocably?",
      "back": "Back",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteLearningDepartment": "Delete department",
      "save": "Save",
      "learningDepartment": "Department",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>